import React, { useState } from "react";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";

import {
  CloseButton,
  FormTitle,
  InfoArea,
  StyledPaper,
  StyledAddressContainer
} from "./styles";

import Dialog from "@material-ui/core/Dialog";
import CloseIcon from "@material-ui/icons/Close";
import Input from "../inputField";
import PledgxLogo from "../../assets/common/pledgxLogo";
import { emailRE } from "../../common/regex";
import { FunctionalButton } from "../functionalButton";
import { AddressAutoFields } from "../../pages/contractorDashboard/profileSetup/AddressAutoFields";
import { addAssociation } from "../../data/actions/dataMaintenance";
import { useDispatch } from "react-redux";
import updateObjectByPath from "../../common/updateObjectByPath";
import countriesInArray from "../../assets/locale/countriesInArray";
import Select from "../../components/selectField";
import { formatPhoneNumber } from "../../common/formatPhoneNumber";
import { phoneRegex } from "../../common/regex";
import { SuccessPopup } from "../../pages/adminToolsDashboard/SuccessPopup";

export const AddAssociationPopup = ({
  setOpenDialog,
  openDialog,
  isMobile,
  label,
  buttonLabel
}) => {

  const [data, setData] = useState({});
  const dispatch = useDispatch();
  const [openSuccessPopup, setOpenSuccessPopup] = useState(false);
  const [phoneNumber, setPhoneNumber] = React.useState(data?.phone);

  const handlePhoneNumberChange = (value) => {
    setData({ ...data, phone: value });
  };



  const onChangeData = (attribute, val) => {
    const updatedData = { ...data };
    updateObjectByPath(updatedData, attribute, val);
    setData({ ...updatedData });
  };


  const handleSave = () => {
    dispatch(
      addAssociation(
        data,
        () => {
          setOpenSuccessPopup(true);
          setData({});
        },
        () => { }
      )
    );
  };

  const handleClose = () => {
    setOpenDialog(false);
  };


  return (
    <Dialog
      open={openDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="md"
    >
      <StyledPaper elevation={0} isMobile={isMobile}>
        <CloseButton aria-label="close" onClick={handleClose}>
          <CloseIcon />
        </CloseButton>
        <PledgxLogo width={isMobile ? 45 : ""} height={isMobile ? 45 : ""} />
        <FormTitle style={{ marginTop: 10 }}>
          {label || "Add Association"}
        </FormTitle>
        <InfoArea isMobile={isMobile} marginTop="0px">
          <Input
            id="inputWrap"
            label="Name"
            type="text"
            placeholder=""
            labelSize="12px"
            fontSize="18px"
            value={data?.name}
            setValue={(val) => onChangeData("name", val)}
            validateFunc={(item) => item.length > 0}
            noCheckIcon={true}
            noErrorBorder={true}
          />

          <Input
            id="inputWrap"
            label="Website"
            type="text"
            placeholder=""
            labelSize="12px"
            fontSize="18px"
            value={data?.website}
            setValue={(val) => onChangeData("website", val)}
            validateFunc={(item) => item.length > 0}
            noCheckIcon={true}
            noErrorBorder={true}
          />

          <StyledAddressContainer>

          <Input
            id="fullWidthInputWrap"
            label="Email"
            type="text"
            placeholder=""
            labelSize="12px"
            fontSize="18px"
            value={data?.email}
            setValue={(val) => onChangeData("email", val)}
            validateFunc={(item) => emailRE.test(item)}
            noCheckIcon={true}
            noErrorBorder={true}
            style={{marginRight: "-265px"}}
          />
 
          <div style={{ marginTop: "24px", width: "100%", marginLeft: '250px', marginRight: '16px' }}>
            <label htmlFor="phone" style={{ fontSize: "12px" }}>
              Phone Number
            </label>
            <div style={{ height: "48px", width: "100%", marginTop: "-10px" }}>
              <PhoneInput
                id="phone"
                country={"ca"}
                value={phoneNumber}
                onChange={handlePhoneNumberChange}
                style={{ marginTop: "16px", width: "100%", height: "100%" }}
                inputStyle={{
                  fontSize: "18px",
                  padding: "8px",
                  lineHeight: "24px",
                  marginLeft: "20px",
                  paddingLeft: "28px",
                  height: "100%",
                  width: "98%",
                  marginRight: "20px",
                }}
                dropdownStyle={{ fontSize: "18px", lineHeight: "24px" }}
              />
            </div>
          </div>


          <div className="oneThirdInputWrap">
            <Select
              style={{ marginRight: "0px", width: "150px"}}
              label="Country"
              options={countriesInArray.map((country) => ({
                value: country.countryName,
                label: country.countryName,
              }))}
              value={data?.country}
              setValue={(val) => onChangeData("country", val)}
              validateFunc={(item) => Boolean(item)}
              noCheckIcon={true}
              showDropdownIndicator={true}
            />
          </div>

          </StyledAddressContainer>


          <AddressAutoFields data={data} setData={onChangeData} />

        </InfoArea>

        <FunctionalButton
          width="30%"
          marginTop="16px"
          marginRight="10px"
          handleButton={() => {
            handleSave();
          }}
          buttonTitle={buttonLabel || "SAVE"}
        />

        <SuccessPopup
          setOpenPopup={setOpenSuccessPopup}
          openPopup={openSuccessPopup}
          isMobile={isMobile}
        />
      </StyledPaper>
    </Dialog>
  );
};
